<template>
  <div>
    <PageHeader title="契約中の物件" class="list">
      <template #title-header-content>
        <div class="flex-1 pl-2 flex ml-6 justify-end items-center">

          <div v-if="loading" class="w-fit m-auto text-white font-bold animate-pulse">MAP情報取得中...</div>
          <div v-else-if="!start" class="w-fit m-auto text-white font-bold animate-pulse">検索条件をセットし、検索ボタンを押してください</div>
          <div v-else-if="!list||!list.length" class="w-fit m-auto text-white font-bold animate-pulse">対象データはありません</div>

          <div class="mr-2">
            <PrimaryButton text="検索" class="w-40" @click="getData()"></PrimaryButton>
          </div>

          <div class="text-white font-bold">{{ list.length }} 件</div>

          <Icon 
            iconName="Refresh" 
            :clickable="false" 
            :class="{'animate-spin': loading}" 
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="refresh"
          />
        </div>
      </template>
      <template #page-header-content>
        <div class="flex justify-end">
          <!-- 年度 -->
          <div class="mr-2 mt-auto">
            <input
              type="number"
              min="2022"
              max="2999"
              placeholder="年度 検索"
              class="py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 font-bold w-20 text-center" 
              v-model="filter.year"
            /> 
            <span class="pl-1 pr-2 font-bold text-white text-sm">年度</span>
          </div>

          <!-- 住所 -->
          <div class="mr-2 mt-auto">
            <input
              type="search"
              placeholder="住所 検索"
              class="border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900"
              v-model="filter.address"
            /> 
          </div>

          <!-- 作業名 -->
          <div class="mr-2 mt-auto">
            <input
              type="search"
              placeholder="作業区分・作業名 検索"
              class="border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900"
              v-model="filter.work"
            /> 
          </div>

          <!-- 外注先 -->
          <div class="mr-2 mt-auto">
            <WmsSuggestInput
              name="purchase" 
              :dynamic="false"
              :incrementalSearch="false"
              :selectionItems="purchaseList"
              displayField="name"
              placeholder="発注先"
              v-model="filter.purchase"
              :clearable="true"
              class="suggest border-transparent rounded-md leading-5 focus:outline-none focus:bg-white focus:ring-white focus:border-white focus:placeholder-gray-500 focus:text-gray-900 sm:text-sm"
              :embed="true"
            />
          </div>

          <!-- 物件名 -->
          <div class="mr-2 mt-auto">
            <input
              type="search"
              placeholder="物件 検索"
              class="border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900"
              v-model="filter.site"
            /> 
          </div>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-32 w-screen bottom-4 -mt-2 leading-8 row">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full w-full flex">
          
          <!-- エリア絞り込み -->
          <div class="w-fit whitespace-nowrap overflow-auto p-2">
            <div class="font-bold text-gray-700 text-sm mb-3">
              エリア <span class="top-0.5 text-red-500"> * </span>
            </div>
            <div class="text-blue-700 text-sm font-bold mb-3">
              <div @click="all(true)" class="w-20 mb-2 cursor-pointer">全選択</div>
              <div @click="all(false)" class="cursor-pointer">全解除</div>
            </div>
            <div v-for="(row, i) in area" :key="'e'+i">
              <input
                type="checkbox"
                :id="i"
                class="cursor-pointer"
                :class="row.class?'green-check':''"
                v-model="row.check"
              >
              <label :for="i" class="font-bold text-sm ml-1 p-1 cursor-pointer" :class="row.class">{{ row.area }}</label>
            </div>
          </div>
          
          <!-- MAP -->
          <div v-if="!start" class="w-fit m-auto  font-bold animate-pulse">取得したいエリアをチェックし、検索ボタンを押してください。<p>件数が多いとMAPに表示するまでに時間がかかります。</p><p class="text-red-700">検索条件を細かくセットすることをお勧めします。</p></div>
          <div v-else id="map" ref="map" class="w-full h-full"></div>
        </div>
      </div>
    </main>

    <!-- 詳細モーダル -->
    <MapDetailModal 
      v-model="modalShow"
      :open="modalShow"
      :siteCode="siteCode"
      :year="filter.year"
      @closed="modalShow=false"
    />

  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
import * as constants from '@libs/constants'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as moment from 'moment'
import MapDetailModal from '../components/MapDetailModal.vue'
import PageModel from '../../main/pages/PageModel.vue'

var map

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    PrimaryButton,
    WmsSuggestInput,
    MapDetailModal
  },

  data() {
    return {
      loading: false,
      // データ
      list: [],
      // エリアリスト
      area: constants.AREA_SELECTIONS2,
      // 検索ボタンを1度でも押した
      start: false,
      // 検索
      filter: {
        // 表示年度
        year: Number(moment().add(-2, 'months').format('YYYY')),

      },
      // 発注先リスト
      purchaseList: [],
      // 詳細モーダル
      modalShow: false,
      // モーダル表示対象コード
      siteCode: null
    }
  },

  mounted() {
    this.getPurchaseList()
  },

  computed: {
  },

  methods: {
    async refresh() {
      await this.getData()
    },

    /**
     * データ取得
     */
    async getData() {
      if (!this.filter.year) {
        await dialogs.showErrorDialog('年度を入力してください', '年度は必須です。')
        return
      }
      const isArea = this.area.some(a => a.check)
      if (!isArea) {
        await dialogs.showErrorDialog('エリアをどれかチェックしてください', 'エリアの指定がないと、0件になります。')
        return
      }

      this.start = true
      this.loading = true
      let res = await backend.postData('akbsTable/getMapData', { ...this.filter, area: this.area })
      this.list = res.data.data
      await this.initMap()
      this.loading = false
    },

    /**
     * 発注先名リスト取得
     */
    async getPurchaseList() {
      if (!this.filter.year) {
        return
      }
      let res = await backend.searchData('akbsTable/getPurchaseList', { year: this.filter.year })
      if (res.data.data.length) {
        this.purchaseList = res.data.data
      }
    },

    /**
     * エリア全選択、全解除
     */
    all(val) {
      this.area.forEach((a) => {
        a.check = val
      })
    },

    /**
     * マップ生成
     */
    async initMap() {
      const locations = []

      // let idx = 0
      let maCnt = 0
      let centLat = 0
      let centLng = 0

      for await (const row of this.list) {
        if (row.latitude && row.longitude) {
          maCnt ++
          centLat += Number(row.latitude)
          centLng += Number(row.longitude)
        
          locations.push(
            {
              name: row.name,
              address: row.address,
              position: {
                lat: Number(row.latitude),
                lng: Number(row.longitude)
              }, 
              row: row,
            }
          )
        }
      }

      if (maCnt > 0) {
        centLat = centLat / maCnt
        centLng = centLng / maCnt
      } else {
       //検索0の場合 
        centLat += 35.624315
        centLng += 139.579387
      }

      let zoomVal = 10
      let centVal = { lat: centLat, lng: centLng }

      map = new google.maps.Map(this.$refs.map, {
          zoom: zoomVal,
          center: centVal,
        })

      locations.forEach((pos) => {
        let marker = new google.maps.Marker({
          map: map,
          name: pos.name,
          position: pos.position,
          row: pos.row,
          label: {
            // text: String(pos.count), // 同住所の件数
            text: ' ',
            color: "#ffffff", // ラベルのテキストの色を白に設定
          },
          optimized: false,
          zIndex: 1
        })

        marker.addListener("click", async () => {
          this.siteCode = marker.row.code
          this.modalShow = true
        })
        return marker
      })
    },
  }
}
</script>

<style scoped>
.green-check {
  color: rgb(39, 152, 39);
}

.suggest >>> input[type=text] {
  height: 39px;
  border-radius: 0.375rem !important;
  }
</style>